/**
 * フライト情報に指定された配送情報との紐づけを解除するダイアログ
 */
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Alert } from "@mui/material"
import { FlightInfo } from "adoms-common-lib"
import React from "react"
import { LoadingMark } from "../atoms/LoadingMark"
import { APIConnector } from "../../connector/APIConnector"


type OrderInfoDisconnectDialogProps = {
    /**
     * 配送依頼を紐付けるフライト
     */
    flight: FlightInfo,
    /**
     * 紐づけを続ける配送依頼
     */
    continueConnectOrderIDs?: string[],
    /**
     * ダイアログがオープンしているかどうか
     */
    isOpen: boolean,
    /**
     * ダイアログをクローズする際のハンドラ
     */
    onClose: (event: any) => void
}

export const OrderInfoDisconnectDialog: React.FC<OrderInfoDisconnectDialogProps> = (props) => {
    const [isLoding, setIsLoading] = React.useState(false);
    const [errorFlag, setErrorFlag] = React.useState(false);
    /**
     * ダイアログをクローズする
     */
    const handleDialogClose = async (event: any) => {
        setErrorFlag(false);
        setIsLoading(true);
        const apigw = APIConnector.instance;
        await apigw.putFlightStatusChange(props.flight, props.continueConnectOrderIDs ?? []).then((response => {
            props.onClose(event);
        })
        ).catch((error) => {
            setErrorFlag(true);
        });
        setIsLoading(false);
    };
        
    return (
        <Dialog
            open={props.isOpen}
            onClose={props.onClose}
            maxWidth="sm"
        >
            <DialogTitle>配送依頼の紐づけ解除</DialogTitle>
            <DialogContent>
                {isLoding ? (
                    <LoadingMark isDisplayLoadingMark={isLoding} />
                ) : null}
                {/* エラー用のアラート */}
                {errorFlag ? (
                    <Alert severity="error">
                        配送依頼の紐づけ解除に失敗しました。
                        複数回実行しても同じエラーが発生する場合は、管理者にお問い合わせください。
                    </Alert>
                ) : null}
                {/* ローディング用のスピナー */}
                <DialogContentText>
                    フライト情報に指定された配送情報との紐づけを解除します。
                    <br />
                    よろしいですか？
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} color="primary">
                    キャンセル
                </Button>
                <Button onClick={handleDialogClose} color="secondary">
                    削除
                </Button>
            </DialogActions>
        </Dialog>
    )
}